
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { CarrierAccountType } from '@/features/carrier-accounts/types';
import FeatureFlagMixin from '@/features/common/mixins/featureFlagMixin';
import { isRegisteredThroughMerchant, isFedexRegistration } from '../helpers';

@Component
export default class CarrierAccountItem extends Mixins(FeatureFlagMixin) {
  @Prop({ required: true }) carrierAccount!: CarrierAccountType;

  @Prop({ required: false, default: false }) installing!: boolean;

  protected featureKeysToLoad = ['useFedexNewRegistration'];

  private isRemoving = false;

  get isEditAvailable(): boolean {
    if (!this.carrierAccount) return true;

    const { carrierCode } = this.carrierAccount;

    if (isFedexRegistration(carrierCode) && this.featureFlags.useFedexNewRegistration) {
      return false;
    }

    return !isRegisteredThroughMerchant(carrierCode);
  }

  get isInstallIncomplete(): boolean {
    return this.carrierAccount?.isAvailable === false;
  }

  get accountStatus(): string {
    if (this.isInstallIncomplete) {
      return this.$t('carrierAccounts.accountsTable.table.body.installationIncomplete') as string;
    }

    return this.keyType;
  }

  get keyType(): string {
    if (!this.carrierAccount) return '';

    return this.$t('carrierAccounts.accountsTable.table.body.keyProduction') as string;
  }
}
